module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    class: [{
      'weui-btn_primary': _vm.primary,
      'weui-btn_warn': _vm.warn,
      'weui-btn_default': _vm.origin,
      'weui-btn_plain-default': _vm.plain,
      'weui-btn_plain-primary': _vm.plainPrimary,
      'weui-btn_mini': _vm.mini,
      'weui-btn_disabled': _vm.disabled
    }, 'weui-btn'],
    attrs: {
      "href": "javascript:;",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onItemClick
    }
  }, [_vm._t("default")], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-6ad6aa35!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/button.vue
// module id = 261
// module chunks = 0